import React, { useState } from "react";
import "../css/Workout.css";

const Workout = () => {
  const [tab, setTab] = useState("strength");

  return (
    <div className="wk4">

      {/* ================= HERO ================= */}
      <section className="wk4-hero">
        <div className="wk4-hero-inner">
          <h1>Move Your Way</h1>
          <p>Playful programs built for strength, energy & long-lasting joy.</p>
        </div>
      </section>



      {/* ================= TABS ================= */}
      <section className="wk4-tabs">
        <div 
          className={`wk4-tab ${tab==="strength"?"active":""}`}
          onClick={()=>setTab("strength")}
        >
          Strength
        </div>

        <div 
          className={`wk4-tab ${tab==="cardio"?"active":""}`}
          onClick={()=>setTab("cardio")}
        >
          Cardio
        </div>

        <div 
          className={`wk4-tab ${tab==="flex"?"active":""}`}
          onClick={()=>setTab("flex")}
        >
          Flexibility
        </div>
      </section>



      {/* ================= TAB CONTENT ================= */}
      <section className="wk4-content">

        {tab === "strength" && (
          <div className="wk4-block">
            <h2>Strength Sessions</h2>
            <p>
              Build power the fun way — colorful dumbbells, upbeat music, and 
              movements that help you feel unstoppable.
            </p>
          </div>
        )}

        {tab === "cardio" && (
          <div className="wk4-block">
            <h2>Cardio Play</h2>
            <p>
              Jump, dance, sprint, groove. Our cardio tracks feel like a party 
              your heart gets to enjoy.
            </p>
          </div>
        )}

        {tab === "flex" && (
          <div className="wk4-block">
            <h2>Flexibility Flow</h2>
            <p>
              Slow movements, light energy, deep breaths, and easy stretches 
              for a relaxed body and a calm mind.
            </p>
          </div>
        )}

      </section>



      {/* ================= GRID OF MOVEMENTS ================= */}
      <section className="wk4-grid-section">
        <div className="wk4-grid">

          <div className="wk4-card tall" style={{backgroundImage:`url(https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg)`}}>
            <span>Full Body</span>
          </div>

          <div className="wk4-card" style={{backgroundImage:`url(https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg)`}}>
            <span>Core Play</span>
          </div>

          <div className="wk4-card wide" style={{backgroundImage:`url(https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg)`}}>
            <span>Strength Mix</span>
          </div>

          <div className="wk4-card" style={{backgroundImage:`url(https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg)`}}>
            <span>Cardio Burst</span>
          </div>

          <div className="wk4-card tall" style={{backgroundImage:`url(https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg)`}}>
            <span>Mobility Flow</span>
          </div>

        </div>
      </section>



      {/* ================= COACHING PANEL ================= */}
      <section className="wk4-coach">
        <div className="coach-inner">
          <h2>Your body. Your rhythm.</h2>
          <p>
            SHANK workouts are designed for real humans — energetic, imperfect, 
            curious, and ready to grow. We help you enjoy the journey, not stress it.
          </p>
        </div>
      </section>

    </div>
  );
};

export default Workout;
